





import { Vue, Component } from "@/shared/vuepack";

@Component
export default class AllegacyFooterInvestment extends Vue {
}
